import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Returns from '../../components/returns';
import ThankYou from '../../components/returns/thank-you';
import PageNotFound from '../../components/page-not-found';
const ReturnsContainer = () => (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: '/returns/thank-you', component: ThankYou }),
    React.createElement(Route, { path: '/returns', component: Returns }),
    React.createElement(Route, { component: PageNotFound })));
export default ReturnsContainer;
